import React from 'react'
import styles from './schools-list.styles'
import injectSheet from 'react-jss'
import School from './school/school.container'

const SchoolsList = ({ classes, schools, emptyValueError, noResultsError }) =>
  emptyValueError ? (
    <div className={classes.message}>
      Start searching for your school via name and location
    </div>
  ) : noResultsError ? (
    <div className={classes.message}>
      There is no schools matching search criteria
    </div>
  ) : (
    <div>
      {schools.map(school => (
        <School
          key={school.id}
          id={school.id}
          title={school.title}
          address={`${school.city}, ${
            school.postcode ? school.postcode + ', ' : ''
          }${school.country}`}
        />
      ))}
    </div>
  )

export default injectSheet(styles)(SchoolsList)
